package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class CravingObservationQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    habit: String,
    date: String,
    sensations: String,
    zones: String,
    intensity: Long,
    outcome: String,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(1_393_794_013, arrayOf("craving_observation"), driver,
      "CravingObservation.sq", "selectAll",
      "SELECT craving_observation.id, craving_observation.habit, craving_observation.date, craving_observation.sensations, craving_observation.zones, craving_observation.intensity, craving_observation.outcome, craving_observation.created_at, craving_observation.updated_at, craving_observation.is_deleted, craving_observation.deleted_at, craving_observation.synced_at FROM craving_observation WHERE is_deleted = 0 ORDER BY created_at DESC") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getLong(5)!!,
      cursor.getString(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10),
      cursor.getLong(11)
    )
  }

  public fun selectAll(): Query<Craving_observation> = selectAll { id, habit, date, sensations,
      zones, intensity, outcome, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Craving_observation(
      id,
      habit,
      date,
      sensations,
      zones,
      intensity,
      outcome,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByHabit(habit: String, mapper: (
    id: String,
    habit: String,
    date: String,
    sensations: String,
    zones: String,
    intensity: Long,
    outcome: String,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByHabitQuery(habit) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getLong(5)!!,
      cursor.getString(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10),
      cursor.getLong(11)
    )
  }

  public fun selectByHabit(habit: String): Query<Craving_observation> = selectByHabit(habit) { id,
      habit_, date, sensations, zones, intensity, outcome, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Craving_observation(
      id,
      habit_,
      date,
      sensations,
      zones,
      intensity,
      outcome,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    habit: String,
    date: String,
    sensations: String,
    zones: String,
    intensity: Long,
    outcome: String,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-591_059_186, arrayOf("craving_observation"), driver,
      "CravingObservation.sq", "selectDirty",
      "SELECT craving_observation.id, craving_observation.habit, craving_observation.date, craving_observation.sensations, craving_observation.zones, craving_observation.intensity, craving_observation.outcome, craving_observation.created_at, craving_observation.updated_at, craving_observation.is_deleted, craving_observation.deleted_at, craving_observation.synced_at FROM craving_observation WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getLong(5)!!,
      cursor.getString(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10),
      cursor.getLong(11)
    )
  }

  public fun selectDirty(): Query<Craving_observation> = selectDirty { id, habit, date, sensations,
      zones, intensity, outcome, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Craving_observation(
      id,
      habit,
      date,
      sensations,
      zones,
      intensity,
      outcome,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    habit: String,
    date: String,
    sensations: String,
    zones: String,
    intensity: Long,
    outcome: String,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getLong(5)!!,
      cursor.getString(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10),
      cursor.getLong(11)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Craving_observation> = selectByIdAnyState(id) {
      id_, habit, date, sensations, zones, intensity, outcome, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Craving_observation(
      id_,
      habit,
      date,
      sensations,
      zones,
      intensity,
      outcome,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    habit: String,
    date: String,
    sensations: String,
    zones: String,
    intensity: Long,
    outcome: String,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(-455_053_087, """
        |INSERT INTO craving_observation(id, habit, date, sensations, zones, intensity, outcome, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 9) {
          bindString(0, id)
          bindString(1, habit)
          bindString(2, date)
          bindString(3, sensations)
          bindString(4, zones)
          bindLong(5, intensity)
          bindString(6, outcome)
          bindLong(7, created_at)
          bindLong(8, updated_at)
        }
    notifyQueries(-455_053_087) { emit ->
      emit("craving_observation")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_318_877_341,
        """UPDATE craving_observation SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(1_318_877_341) { emit ->
      emit("craving_observation")
    }
  }

  public fun update(
    habit: String,
    date: String,
    sensations: String,
    zones: String,
    intensity: Long,
    outcome: String,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-110_106_895,
        """UPDATE craving_observation SET habit = ?, date = ?, sensations = ?, zones = ?, intensity = ?, outcome = ?, updated_at = ? WHERE id = ?""",
        8) {
          bindString(0, habit)
          bindString(1, date)
          bindString(2, sensations)
          bindString(3, zones)
          bindLong(4, intensity)
          bindString(5, outcome)
          bindLong(6, updated_at)
          bindString(7, id)
        }
    notifyQueries(-110_106_895) { emit ->
      emit("craving_observation")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(-2_081_363_610,
        """UPDATE craving_observation SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(-2_081_363_610) { emit ->
      emit("craving_observation")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(-1_773_196_337,
        """UPDATE craving_observation SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(-1_773_196_337) { emit ->
      emit("craving_observation")
    }
  }

  private inner class SelectByHabitQuery<out T : Any>(
    public val habit: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("craving_observation", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("craving_observation", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_866_459_033,
        """SELECT craving_observation.id, craving_observation.habit, craving_observation.date, craving_observation.sensations, craving_observation.zones, craving_observation.intensity, craving_observation.outcome, craving_observation.created_at, craving_observation.updated_at, craving_observation.is_deleted, craving_observation.deleted_at, craving_observation.synced_at FROM craving_observation WHERE habit = ? AND is_deleted = 0 ORDER BY created_at DESC""",
        mapper, 1) {
      bindString(0, habit)
    }

    override fun toString(): String = "CravingObservation.sq:selectByHabit"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("craving_observation", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("craving_observation", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-678_617_797,
        """SELECT craving_observation.id, craving_observation.habit, craving_observation.date, craving_observation.sensations, craving_observation.zones, craving_observation.intensity, craving_observation.outcome, craving_observation.created_at, craving_observation.updated_at, craving_observation.is_deleted, craving_observation.deleted_at, craving_observation.synced_at FROM craving_observation WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "CravingObservation.sq:selectByIdAnyState"
  }
}
